module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-check-fill-87ba2bc8.svg";